export * from './user.enums'
export * from './company.enums'
export * from "./medias.enums"
export * from './application.enum'
export * from './job-creation-utils.enums'
export enum LanguageCode {
  FR = 'fr',
  EN = 'en',
}

export enum ReportVariables {
  JOB_NAME  = '${nomJob}',
  PUBLICATION_DATE = '${datePublication}',
  DEPARTMENT = '${departement}',
  OFFICE = '${bureau}',
  COMPANY_NAME = '${nomEntreprise}',
  JOB_PIPELINE_LIST = '${pipelineTraitement}',
  JOB_CRITERIA_LIST = '${listCritereNotation}',
  EVALUATION_PER_CANDIDATE = '${evaluationParCandidat}',
  LIST_ACCEPTED_APPLICATIONS_COUNT = '${listCandidatureAccepte}',
  ACCEPTED_APPLICATIONS_COUNT = '${nbCandidatureAcceptees}',
  APPLICATIONS_COUNT = '${nbCandidatures}',
  REJECTED_APPLICATIONS_COUNT = '${nbCandidatureRefusees}'
}

export enum JobSubModuleType {
    CVTHEQUE = "CVTHEQUE",
    SCORING = "SCORING",
    SCORING_V2 = "SCORING_V2",
    SIGNATURE = "SIGNATURE",
    STANDARD = "STANDARD",
    AVAILABILITY_SURVEY = "AVAILABILITY_SURVEY",
    CRITERIA_SECTION_RESTRICTION = "CRITERIA_SECTION_RESTRICTION"
}

export enum JobDefaultProfiles {
  MANAGER_JOB = 'MANAGER_JOB',
  ADMIN_JOB = 'ADMIN_JOB',
  RECRUITER_JOB = 'RECRUITER_JOB',
}